import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import Helmet from 'react-helmet'
import { Box, Alert, AlertTitle, Card, Button, CircularProgress } from "@mui/material";
import estimatedTimeArrivalService from "../../services/estimatedTimeArrival.service";
import { Role } from "../../common/roles/role";
import Map, { NavigationControl, FullscreenControl, Marker } from "react-map-gl/maplibre";
import { withIdentityPoolId } from "@aws/amazon-location-utilities-auth-helper";
import PinIcon from "../../components/maps/PinIcon";

const region = process.env.REACT_APP_REGION
const mapName = process.env.REACT_APP_MAP_NAME
const apiKey = process.env.REACT_APP_MAP_API_KEY
const identityPoolId = process.env.REACT_APP_IDENTITY_POOL_ID

export default function EstimatedTimeArrival() {

  const [viewState, setViewState] = useState({
    latitude: null,
    longitude: null,
    zoom: 15,
  });

  // ready Identity Pool for map
  const [authHelper, setAuthHelper] = useState("");
  const [isIdPool, setIsIdPool] = useState(false)

  useEffect(() => {
    const getAuthHelper = async () => {
      let result = await withIdentityPoolId(identityPoolId);
      setAuthHelper(result);
      setIsIdPool(true);
    };
  
    // Fetching Data on Initial Load
    getAuthHelper();
  }, [identityPoolId]);

  const { user } = useSelector((state) => state.auth);
  const { role } = user;
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    setMessage('');
    estimatedTimeArrivalService
      .get({
        role,
      })
      .then((data) => {
        if (data.data?.message) {
          setMessage(data.data.message);
          setViewState({
            latitude: data.data.latitudCliente,
            longitude: data.data.longitudCliente,
            zoom: 15,
          });
        }
        if (data.errorMessage) {
          setErrorMessage(data.errorMessage);
        }
      });
    }, [role, toggle]);

  if (errorMessage) {
    return (
      <Box sx={{ my: 2 }}>
        <Alert severity="error">
          <AlertTitle sx={{ mb: 0 }}>No disponible temporalmente</AlertTitle>
        </Alert>
      </Box>
    );
  }

  return (
    <>
      <h3>Tiempo estimado de llegada</h3>
      <Helmet>
        <title>Tiempo estimado de llegada - Marina BCN</title>
      </Helmet>
      <Box sx={{ my: 2 }}>
        <Alert severity="info">
          <AlertTitle sx={{ mb: 0 }}>{message || 'Calculando...' }</AlertTitle>
        </Alert>
      </Box>
      { (isIdPool && message && viewState.latitude && viewState.longitude) ?
        <Card variant="outlined" sx={{ height: 430, display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', '& details.maplibregl-ctrl.maplibregl-ctrl-attrib': { display: 'none' } }}>
          <Map
            // See https://visgl.github.io/react-map-gl/docs/api-reference/map
            initialViewState={{ ...viewState }}
            reuseMaps='true'
            dragPan={false}
            doubleClickZoom={false}
            scrollZoom={false}
            mapStyle={`https://maps.geo.${region}.amazonaws.com/maps/v0/maps/${mapName}/style-descriptor?key=${apiKey}`}
            {...authHelper.getMapAuthenticationOptions()}
          >
            {/* <NavigationControl position="bottom-right" showZoom showCompass={false} /> */}
              <Marker
                latitude={viewState.latitude}
                longitude={viewState.longitude}
                anchor="bottom"
              >
                <PinIcon size={35} isSelected={true} color={1}/>
              </Marker>
          </Map>
        </Card>
      : 
        <Card variant="outlined" sx={{ height: 430, display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', '& details.maplibregl-ctrl.maplibregl-ctrl-attrib': { display: 'none' } }}>
          <CircularProgress />
        </Card>
      }
      <Button
            sx={{ mt: '10px' }}
            variant="contained"
            color="secondary"
            type="submit"
            onClick={() => setToggle(!toggle)}
            disabled={!message}
          >
        Recalcular
      </Button>
    </>
  )
}
